import { Component, Input } from '@angular/core';

type AvailableIcons =
    | ''
    | 'doc-front'
    | 'like'
    | 'key'
    | 'lock-open'
    | 'lock-closed'
    | 'doc-back'
    | 'selfie'
    | 'loading-spinner'
    | 'close-circle'
    | 'check'
    | 'doc-decline';

@Component({
    selector: 'dp-icon-svg',
    templateUrl: './icon-svg.component.html',
    styleUrls: ['./icon-svg.component.scss']
})
export class IconSvgComponent {
    @Input() public name: AvailableIcons = '';
    @Input() public width = '';
    @Input() public height = '';
}
